import Seo from "@/components/Seo";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import Services from "@/components/Services";
import { useLang } from "@/lib/i18n";

export default function ServicesPage() {
  const { lang } = useLang();
  return (
    <div className="bg-[#050505] min-h-screen">
      <Seo
        title={lang === "zh" ? "服务项目 — DFE 娛樂夢工廠" : "Services — Dream Factory Entertainment"}
        description={lang === "zh" ? "演唱会与音乐节制作、艺人管理、音乐制作、商业活动、接待与现场后勤管理、技术制作等专业服务。" : "Concert & festival production, artist management, music production, corporate events, hospitality, on-ground logistics and technical production."}
      />
      <NavBar />
      <main className="pt-16">
        <Services />
      </main>
      <Footer />
    </div>
  );
}
